import { createContext, useContext } from 'react';

import type { GMetrixTableHandle } from 'components/GMetrixTable/GMetrixTable';
import type { CallToActionProps } from 'components/layout/page/CallToAction';

// A single component's contribution to the page header. Any descendant of a
// PageWithHeader can "dial out" an export control and/or a call-to-action into
// the header via useRegisterHeaderControls.
export type PageHeaderControl = {
    actions?: CallToActionProps[];
    cta?: CallToActionProps;
    exportHandle?: GMetrixTableHandle | null;
};

export type PageHeaderContextValue = {
    register: (id: symbol, control: PageHeaderControl) => void;
    unregister: (id: symbol) => void;
};

// Undefined default lets consumers (e.g. GMetrixTable) detect the absence of a
// PageWithHeader ancestor and fall back to an inline control.
export const PageHeaderContext = createContext<PageHeaderContextValue | undefined>(undefined);
PageHeaderContext.displayName = 'PageHeaderContext';

export const usePageHeader = () => useContext(PageHeaderContext);
